import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import { EditText } from 'react-edit-text';
import { formatPhone } from '../helpers/formatting';
import 'react-edit-text/dist/index.css';
import { 
  HiPencilAlt
} from "react-icons/hi";

import useToken from '../hooks/useToken';

import updateUserAction from '../actions/updateUserAction';

import '../App.css';

export default function UserForm() {
  const { token } = useToken();
  
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  
  const [password, setPassword] = useState();
  const [passwordInvalid, setPasswordInvalid] = useState(false);

  const handleUserUpdate = async (input) => {
    if (!validate(input)) {
      return;
    }

    let args = {};
    args[input.name] = input.value
    
    const updatedUser = await updateUserAction(token, args);
    
    if(!!updatedUser.success) {
      setShowAlertSuccess(true);
    } else {
      setShowAlertSuccess(false);
    }

  }

  const validate = input => {
    switch (input.name) {
      case 'password':
        if (!input.value || input.value.length < 8) {
          setPasswordInvalid(true);
          return false;
        } else {
          setPasswordInvalid(false);
        }
        break;
    }
    return true;
  }

  return (
    <Container fluid className="text-start edit-text">
          { showAlertSuccess && 
              <Alert severity="success" icon={true} className="alert">
                <AlertTitle>Profile changes saved</AlertTitle>
              </Alert>
          }    
          <Form>
            <Form.Group as={Row} className="mb-3" controlId="formBasicEmail">
              <Form.Label column sm="4">Password</Form.Label>
              <Col sm="8">
                <EditText 
                  showEditButton 
                  editButtonContent=<HiPencilAlt /> 
                  name="password"
                  type="password"
                  placeholder="**********"
                  onSave={(input) => handleUserUpdate(input)}
                  />
                { passwordInvalid &&
                  <Form.Control.Feedback type="invalid" className="edit-text-validation">
                    Please enter a password at least 8 characters long.
                  </Form.Control.Feedback>
                }
              </Col>

            </Form.Group>
        </Form>
    </Container>
  );
}


